"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instance = exports.rxjsOperators = exports.Constants = exports.SeismicCommon = exports.CommonService = void 0;
var SeismicCommon_1 = require("./monolith/SeismicCommon");
Object.defineProperty(exports, "SeismicCommon", { enumerable: true, get: function () { return SeismicCommon_1.SeismicCommon; } });
var typedi_1 = require("typedi");
var CommonService_decorator_1 = require("./core/decorators/CommonService.decorator");
Object.defineProperty(exports, "CommonService", { enumerable: true, get: function () { return CommonService_decorator_1.CommonService; } });
__exportStar(require("./monolith/services/navigator/index"), exports);
__exportStar(require("./monolith/helper/index"), exports);
exports.Constants = __importStar(require("./monolith/constants/index"));
__exportStar(require("./monolith/services"), exports);
exports.rxjsOperators = __importStar(require("rxjs/operators"));
var instance;
exports.instance = instance;
try {
    var instance_1 = typedi_1.Container.get('instance');
    if (instance_1) {
        throw new Error('There is already an active browser-services instance. Please double check that you are not importing browser-services more than once');
    }
}
catch (ex) {
    exports.instance = instance = new SeismicCommon_1.SeismicCommon();
    typedi_1.Container.set('instance', instance);
}
//# sourceMappingURL=index.js.map